<template>
  <div>
    <v-layout row class="pa-4">
      <v-flex md4>
        <label for="">Form</label>
        <v-autocomplete
          v-model="form.body.name"
          :items="formSlugs"
          item-value="slug"
          item-text="name"
          outline
        ></v-autocomplete>
      </v-flex>
      <v-flex md4>
        <label for="">Label</label>
        <v-text-field
          v-model="form.body.label"
          outline
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        <label for="">locale</label>
        <v-autocomplete
          v-model="form.body.locale"
          :items="langIso"
          item-text="name"
          item-value="code"
          outline
          solo
          label="Search Languages"
        >
        </v-autocomplete>
      </v-flex>
    </v-layout>

    <draggable v-model="form.body.inputs" group="fields" @start="drag=true" @end="drag=false" handle=".handel-fields">
      <div v-for="(field,fieldIndex) in form.body.inputs" class="card-inner-wrapper">
        <fields :field="field"></fields>
        <div class="inner-block-actions">
          <v-btn
            @click="deleteInput(fieldIndex)"
            fab small color=""
            class=""
          ><v-icon  color="red">delete_outline</v-icon></v-btn>
          <v-btn  class="handel-fields" fab small color=""><v-icon color="#666">height</v-icon></v-btn>
        </div>
      </div>
    </draggable>

    <v-btn
      large round flat block
      class="primary--text"
      @click="addFiled()"
    >
      <v-icon>add_circle_outline</v-icon>
      Add Field
    </v-btn>
  </div>

</template>

<script>
  import draggable from 'vuedraggable'
  import fields from "./fields";
  import langIso from "../../../../utils/lang-iso"
  import common from "../../../../utils/common";
  export default {
    name: "formData",
    components: {
      fields,
      draggable
    },
    props: {
      form: {
        type: Object,
        default: ()=> {
          return {}
        }
      }
    },
    data () {
      return {
        langIso,
        formSlugs: [
          {
            name: 'Start Form',
            slug: 'start-form'
          },
          {
            name: 'End Form',
            slug: 'end-form'
          }
        ]
      }
    },
    methods: {
      updateForm () {
        this.$store.dispatch('setSavingStatus',true)
        this.$http.put(`/bot_objects/forms/${this.form.id}`, this.form)
          .then(response=> {
            this.$store.dispatch('setSavingStatus', false)
          })
          .catch(error=>{
            this.$store.dispatch('setLoader',false)
            if (error.response && error.response.status === 401) {
              common.logOut()
            } else {
              this.$store.dispatch('setErrorMessage', false)
            }
          })
      },
      deleteInput(fieldIndex) {
        this.form.body.inputs.splice(fieldIndex,1)
      },
      addFiled() {
        this.form.body.inputs.push({
          type: 'textfield',
          label: '',
          key: '',
          required: false,
          regex: '',
          regex_android: '',
          regex_ios: '',
          errorMessage: ''
        })
      }
    },
    watch: {
      form: {
        handler(val ){
            this.updateForm()
        },
        deep: true
      }
    }
  }
</script>

<style scoped>

</style>
